<section class="section-gap innerPageBg">
    <div class="container">
        <app-global-breadcrumbs class="d-none"></app-global-breadcrumbs>
        <div class="row align-items-center justify-content-between d-flex noHeightSet">
            <div class="col-md-6">
                <div class="imgWraper">
                    <img src="../../../assets/belairtrip_assets/svg_icon/forgot-password.svg" alt="Belairtrip.com Forgot Password" class="img-fluid imgside">
                </div>
            </div>
            <div class="col-md-6">
                <div class="wrapper">
                    <mat-card class="cardSection">
                        <div class="topSection">
                            <div class="titleSection">
                                <p>Forgot Password</p>
                                <h3>Please enter your registered Email.</h3>
                            </div>
                            <form [formGroup]="forgotPassword">
                                <mat-form-field appearance="outline" class="w-100" floatLabel="always">
                                    <mat-label>Email Address</mat-label>
                                    <mat-icon matPrefix>email</mat-icon>
                                    <input matInput placeholder="Email Address" [formControl]="email" maxlength="48px"  [(ngModel)]="emailValue" appDisableCopyPaste appLowercaseInput>
                                    <button *ngIf="emailValue" matSuffix mat-icon-button aria-label="Clear" (click)="emailValue=''">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <mat-error *ngIf="email.hasError('required')"><strong>Email Address</strong> is required.</mat-error>
                                    <mat-error *ngIf="email.hasError('pattern')">Enter a valid <strong>Email Address</strong>.</mat-error>
                                    <mat-hint><span color="warn">**</span>&nbsp;E-mail address should be the same, as given in the <strong>Original Booking</strong> or <strong>Registration Time</strong>.</mat-hint>
                                </mat-form-field>
                                <div class="moreInformation">
                                  <span>We will send you a Reset Password link on your Registered Email ID.</span>
                                  <button mat-button (click)="submit()" class="secoundaryBtn">Reset Password</button>
                                  <!-- <a routerLink="../signIn">Login?</a> -->
                                </div>
                            </form>
                            <p class="massageInfo" *ngIf="emailValue"><span *ngIf="this.listItem.message === 'No User Found'" class="error">!!&nbsp;Sorry, {{this.listItem.message}}.</span><span *ngIf="this.listItem.message !== 'No User Found'">{{this.listItem.message}}.</span></p>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
</section>
<app-common-loader *appLoader="isLoading" [content]="'Forgot Password'"></app-common-loader>